import { Stack } from '@mui/material';
import { RoleList } from './RoleList';
import { SingleRoleDetails } from './SingleRoleDetails';
import { useRoleManagerContext } from './RoleManagerContext';
import type { UserDefinedRoleGroupsInterface } from '@server/role-group-interface';

export const RoleManagerContent = () => {
  const { editRole, initializeEditRole } = useRoleManagerContext();
  return (
    <Stack height="100%">
      {!editRole && (
        <RoleList
          setEditRole={(role: UserDefinedRoleGroupsInterface) => initializeEditRole(role)}
        />
      )}
      {editRole && <SingleRoleDetails role={editRole} />}
    </Stack>
  );
};
